import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { B100, B200, B300, B400, B50, B75, DN10, DN200, DN30, DN80, DN90, N10, N100, N20, N30, N40, N70, R300 } from '@atlaskit/theme/colors';
const radioThemeColors = {
  light: {
    background: `var(--ds-background-input, ${N10})`,
    backgroundHover: `var(--ds-background-input-hovered, ${N30})`,
    backgroundActive: `var(--ds-background-input-pressed, ${N30})`,
    backgroundChecked: `var(--ds-background-brand-bold, ${B400})`,
    backgroundCheckedHover: `var(--ds-background-brand-bold-hovered, ${B300})`,
    backgroundCheckedActive: `var(--ds-background-brand-bold-pressed, ${B50})`,
    backgroundDisabled: `var(--ds-background-disabled, ${N20})`,
    dotChecked: `var(--ds-icon-inverse, ${N10})`,
    dotDisabled: `var(--ds-icon-disabled, ${N70})`,
    dotActive: `var(--ds-icon-inverse, ${B400})`,
    border: `var(--ds-border-input, ${getBooleanFF('platform.design-system-team.update-border-input_ff9l1') ? N100 : N40})`,
    borderHover: `var(--ds-border-input, ${getBooleanFF('platform.design-system-team.update-border-input_ff9l1') ? N100 : N40})`,
    borderDisabled: `var(--ds-border-disabled, ${N20})`,
    borderFocus: `var(--ds-border-focused, ${B100})`
  },
  dark: {
    background: `var(--ds-background-input, ${DN10})`,
    backgroundHover: `var(--ds-background-input-hovered, ${DN30})`,
    backgroundActive: `var(--ds-background-input-pressed, ${B200})`,
    backgroundChecked: `var(--ds-background-brand-bold, ${B400})`,
    backgroundCheckedHover: `var(--ds-background-brand-bold-hovered, ${B75})`,
    backgroundCheckedActive: `var(--ds-background-brand-bold-pressed, ${B200})`,
    backgroundDisabled: `var(--ds-background-disabled, ${DN10})`,
    dotChecked: `var(--ds-icon-inverse, ${DN10})`,
    dotDisabled: `var(--ds-icon-disabled, ${DN90})`,
    dotActive: `var(--ds-icon-inverse, ${DN10})`,
    border: `var(--ds-border-input, ${getBooleanFF('platform.design-system-team.update-border-input_ff9l1') ? DN200 : DN80})`,
    borderHover: `var(--ds-border-input, ${DN200})`,
    borderDisabled: `var(--ds-border-disabled, ${DN10})`,
    borderFocus: `var(--ds-border-focused, ${B75})`
  }
};
export default function getRadioCustomProperties(mode) {
  const radioColors = radioThemeColors[mode];
  return {
    '--local-background': radioColors.background,
    '--local-background-active': radioColors.backgroundActive,
    '--local-background-checked': radioColors.backgroundChecked,
    '--local-background-checked-active': radioColors.backgroundCheckedActive,
    '--local-background-checked-hover': radioColors.backgroundCheckedHover,
    '--local-background-disabled': radioColors.backgroundDisabled,
    '--local-background-hover': radioColors.backgroundHover,
    '--local-border': radioColors.border,
    '--local-border-disabled': radioColors.borderDisabled,
    '--local-border-hover': radioColors.borderHover,
    '--local-border-focus': radioColors.borderFocus,
    '--local-dot-active': radioColors.dotActive,
    '--local-dot-checked': radioColors.dotChecked,
    '--local-dot-disabled': radioColors.dotDisabled,
    '--local-invalid': `var(--ds-icon-danger, ${R300})`
  };
}